import React from "react";

export interface FinishProps { }

export const Finish = (props: FinishProps) => {

    return (<>
        <p>Thank you for your spam complaint(s).</p>
        <p>If you have given us your email address, you will get an acknowledgement with reference number(s) for your complaint(s).</p>
        <p>After this, we usually won’t contact you again unless we need more information. This is due to the high volume of complaints we receive, which means that it is not possible for us to provide you with an update or outcome about your complaint(s).</p>
        <p>Where we identify a possible breach of the rules, we write to the sender and alert them to their compliance obligations. If you agreed, we will also ask them to remove you from their marketing lists. However, please note the ACMA is not an unsubscribe service.</p>
        <p>If we see indications of serious or ongoing issues, we may investigate. You can find out about our compliance and enforcement actions at <a href="https://acma.gov.au/telemarketing-and-spam-compliance-and-investigations" target="_blank">www.acma.gov.au/telemarketing-and-spam-compliance-and-investigations.</a></p>
    </>
    );
}